export default "__VITE_ASSET__DjNeBxeq__"